import React from 'react';
import Link from 'gatsby-link';

import Align from '@marvelapp/marvel-ui/align';
import Button from '@marvelapp/marvel-ui/button';
import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';

export default function Cta() {
  return (
    <div className="bg-licorice">
      <Spacing size="l" sizeM="xl" position="topBottom" type="padding">
        <Spacing size="l" sizeM="xl" position="top" type="padding">
          <Align type="center">
            <Spacing size="l" position="bottom" type="margin">
              <Spacing size="m" sizeM="0" position="leftRight" type="padding">
                <MaxWidth value={760}>
                  <Heading size="xxxl" weight="semibold" color="white">
                    Make design your company's competitive edge.
                  </Heading>
                </MaxWidth>
              </Spacing>
            </Spacing>
            <Link to="/enterprise">
              <Button shape="rounded" size="large">
                Discover Marvel Enterprise
              </Button>
            </Link>
          </Align>
        </Spacing>
      </Spacing>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/CtaStories/index.js